;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _methods;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "Pay",
  props: ["callback_url", "request_type", "customer_allowed"],
  data: function data() {
    return {
      currency: null,
      logo: null,
      invoice_amount: null,
      agent_fee: 0,
      fee: 0,
      invoice_number: null,
      url: null,
      total_amount: 0,
      pin: null,
      msisdn: null,
      accounts: [],
      type: "none",
      error_message: null,
      processing: false,
      selected_account: null,
      sys_name: null,
      can_view_accounts: false,
      show_otp_page: false,
      one_time_pin_code: null,
      success_message: null,
      hide_account_page: false,
      base_url: "",
      customer_allowed_to_transact: false,
      part_payment: false,
      balance: 0,
      payment_type: null,
      payment_mode_amount: null
    };
  },

  mounted: function mounted() {
    var window = this;
    $("#pesaflowAccountProcessingModal").on("shown.bs.modal", function () {
      $("#account_page").hide();
      $("#main_page").show();
      window.msisdn = null;
      window.pin = null;
      window.processing = false;
      window.error_message = null;
      window.selected_account = null;
      window.accounts = [];
      window.can_view_accounts = false;
      window.hide_account_page = true;
      window.success_message = null;
      window.one_time_pin_code = null;
      window.show_otp_page = false;
    });

    this.invoice_number = this.$attrs["invoice_no"];
    this.invoice_amount = this.$attrs["amount_net"];
    this.currency = this.$attrs["currency"];
    this.fee = this.$attrs["fee"];
    this.agent_fee = this.$attrs["agent_fee"];
    this.url = this.$attrs["status_api_url"];
    this.logo = this.$attrs["logo"];
    this.consumer_secret = this.$attrs["con_secret"];
    this.consumer_key = this.$attrs["con_key"];
    this.sys_name = this.$attrs["sys_name"];
    this.base_url = this.$attrs["base_url"];
    this.set_total_amount();
    if (this.customer_allowed == "false" || this.customer_allowed == false) {
      this.type = "agent";
      this.customer_allowed_to_transact = false;
    } else {
      window.type = null;
      this.customer_allowed_to_transact = true;
    }

    this.partial_payment_allowed = this.$attrs["partial_payment_allowed"];

    if (this.partial_payment_allowed == "false" || this.partial_payment_allowed == false) {
      this.part_payment = false;
      this.payment_type = "full";
      this.setPaymentModeAmount("full");
    } else {
      this.part_payment = true;
    }
  },
  methods: (_methods = {
    setPaymentModeAmount: function setPaymentModeAmount(type) {
      if (type == 'full') this.payment_mode_amount = this.total_amount;
      if (type == 'partial') this.payment_mode_amount = null;
    },

    formatNumber: function formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    set_total_amount: function set_total_amount() {
      this.total_amount = Math.ceil(parseFloat(this.invoice_amount) + parseFloat(this.fee) + parseFloat(this.agent_fee));
    },
    authenticate: function authenticate() {
      var _this = this;

      this.error_message = null;
      this.processing = false;
      if (!this.msisdn || !this.pin) {
        this.error_message = "Phone number and/or PIN is missing!";
        return;
      }

      if (!this.validate_msisdn(this.msisdn)) {
        this.error_message = "Provide a valid phone number";
        return;
      }

      if (!this.type) {
        this.error_message = "Please specify a Customer or Agent account";
        return;
      }
      var auth_url = this.base_url + "/api/" + this.type + "/co/authenticate";
      var payload = {
        msisdn: this.msisdn,
        pin: this.pin,
        invoice_number: this.invoice_number
      };
      this.loading = true;

      Vue.axios.post(auth_url, payload).then(function (response) {
        _this.loading = false;
        _this.accounts = response.data.filter(function (v) {
          return v.currency == _this.currency;
        });
        _this.balance = Number(_this.accounts[0].balance);
        _this.can_view_accounts = true;
        _this.agent_fee = Number(_this.agent_fee) + Number(_this.accounts[0].agent_fee) || 0;
        _this.total_amount = Number(_this.total_amount) + Number(_this.agent_fee);

        $("#main_page").hide();
        $("#account_page").show();
      }).catch(function () {
        _this.loading = false;
        _this.error_message = "Authentication failed. Please check that your PIN or PhoneNumber is correct !";
      });
    },
    validate_msisdn: function validate_msisdn(msisdn) {
      var found = msisdn.match(/\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}/g);
      if (found != null && found.length > 0) return true;
      return false;
    }
  }, (0, _defineProperty3.default)(_methods, "formatNumber", function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }), (0, _defineProperty3.default)(_methods, "request_otp", function request_otp() {
    var _this2 = this;

    var otp_url = this.base_url + "/api/" + this.type + "/otp/request";

    var payload = {
      msisdn: this.msisdn
    };
    Vue.axios.post(otp_url, payload).then(function (response) {
      $("#account_page").hide();
      _this2.show_otp_page = true;
    }).catch(function () {
      _this2.loading = false;
      _this2.error_message = "An error occurred. Try again later !";
    });
  }), (0, _defineProperty3.default)(_methods, "authorize_payment", function authorize_payment() {
    var _this3 = this;

    this.error_message = null;
    var authorize_url = this.base_url + "/api/" + this.type + "/co/make/payment";

    var found = this.accounts.filter(function (v) {
      return v.id == _this3.selected_account;
    });

    if (!this.one_time_pin_code) {
      this.error_message = "Enter the code received on your phone/email";
      return;
    }

    if (!this.selected_account) {
      this.error_message = "Select an account to pay from !";
      return;
    }

    if (parseFloat(found[0].balance) <= 0) {
      this.error_message = "Account has insufficient funds !";
      return;
    }

    if (parseFloat(found[0].balance) < parseFloat(this.payment_mode_amount)) {
      this.error_message = "Account has insufficient funds !";
      return;
    }

    this.processing = true;
    var payload = {
      otp: this.one_time_pin_code,
      invoice_number: this.invoice_number,
      authorized_amount: this.payment_mode_amount,
      pesaflow_account_id: this.selected_account,
      msisdn: this.msisdn
    };
    Vue.axios.post(authorize_url, payload).then(function () {
      _this3.processing = false;
      _this3.can_view_accounts = false;
      _this3.show_otp_page = false;
      _this3.type = null;
      _this3.msisdn = null;
      _this3.pin = null;
      _this3.one_time_pin_code = null;
      _this3.success_message = "Your payment of " + _this3.currency + "." + _this3.payment_mode_amount + " for invoice " + _this3.invoice_number + " was successful. Redirecting you ...";
      $("#main_page").show();
      $("#account_page").hide();

      setInterval(function () {
        _this3.redirect();
      }, 2500);
    }).catch(function () {
      _this3.processing = false;
      _this3.error_message = "Payment failed. Try again Later !";
    });
  }), (0, _defineProperty3.default)(_methods, "redirect", function redirect() {
    if (this.callback_url != null && this.callback_url.length > 0) {
      window.top.location.href = this.callback_url;
    }
  }), _methods)
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"pesaflowAccountProcessingModal","tabindex":"-1","role":"dialog","aria-labelledby":"pesaflowAccountProcessingModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-full",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body d-flex align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mx-auto"},[_c('img',{staticClass:"navbar-brand-img",attrs:{"src":_vm.logo,"alt":"..."}}),_vm._v(" "),_c('div',{staticClass:"card mt-3"},[_c('div',{staticClass:"card-header d-flex justify-content-between"},[_c('p',{staticClass:"mb-0"},[_vm._v("Pay Using "+_vm._s(_vm.sys_name)+" Account")]),_vm._v(" "),_c('p',{staticClass:"mb-0 lead"},[_vm._v("\n                    "+_vm._s(_vm.currency)+" "+_vm._s(_vm.formatNumber(_vm.total_amount))+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.error_message)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n                    "+_vm._s(_vm.error_message)+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.success_message)?_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n                    "+_vm._s(_vm.success_message)+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',[_c('span',{staticClass:"spinner-border spinner-border",attrs:{"role":"status","aria-hidden":"true"}}),_vm._v("\n                    Please wait, loading ...\n                  ")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('br'):_vm._e(),_vm._v(" "),(!_vm.can_view_accounts && !_vm.success_message)?_c('div',{attrs:{"id":"main_page"}},[_c('form',[_c('label',{attrs:{"for":"email"}},[_vm._v("Mobile Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msisdn),expression:"msisdn"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"Enter your phone number"},domProps:{"value":(_vm.msisdn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msisdn=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"email"}},[_vm._v("PIN")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pin),expression:"pin"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Enter your PIN","maxlength":"4"},domProps:{"value":(_vm.pin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pin=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.customer_allowed_to_transact)?_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.type),expression:"type"}],staticClass:"form-check-input",attrs:{"type":"radio","id":"inlineCheckbox1","value":"customer"},domProps:{"checked":_vm._q(_vm.type,"customer")},on:{"change":function($event){_vm.type="customer"}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"inlineCheckbox1"}},[_vm._v("Customer")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.type),expression:"type"}],staticClass:"form-check-input",attrs:{"type":"radio","id":"inlineCheckbox2","value":"agent"},domProps:{"checked":_vm._q(_vm.type,"agent")},on:{"change":function($event){_vm.type="agent"}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"inlineCheckbox2"}},[_vm._v(_vm._s(_vm.sys_name)+" Agent")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-end"},[_c('a',{staticClass:"btn btn-sm btn-outline-primary lift",attrs:{"href":"#"},on:{"click":_vm.authenticate}},[_vm._v("Proceed")])])])]):_vm._e(),_vm._v(" "),(_vm.processing)?_c('div',[_c('span',{staticClass:"spinner-border spinner-border",attrs:{"role":"status","aria-hidden":"true"}}),_vm._v("\n                    Please wait, processing payment ...\n                  ")]):_vm._e(),_vm._v(" "),(_vm.processing)?_c('br'):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"none"},attrs:{"id":"account_page"}},[(_vm.balance <= 0)?_c('p',[_vm._v("\n                      You have insufficient balance. Toup up your account to\n                      proceed\n                    ")]):_vm._e(),_vm._v(" "),_c('label',{attrs:{"for":"email"}},[_vm._v("Select Account to pay from")]),_vm._v(" "),_c('div',[_vm._l((_vm.accounts),function(account,index){return _c('ul',{key:index},[_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_account),expression:"selected_account"}],staticClass:"form-check-input",attrs:{"type":"radio","name":account.name,"id":index},domProps:{"value":account.id,"checked":_vm._q(_vm.selected_account,account.id)},on:{"change":function($event){_vm.selected_account=account.id}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"exampleRadios1"}},[_vm._v("\n                            "+_vm._s(account.name)+"(\n                            "),_c('b',[_vm._v("Bal. "+_vm._s(account.currency)+"\n                              "+_vm._s(_vm.formatNumber(account.balance)))]),_vm._v(")\n                          ")])])])}),_vm._v(" "),_c('br')],2),_vm._v(" "),(_vm.selected_account)?_c('div',[_c('label',{attrs:{"for":"email"}},[_vm._v("Select Payment Mode")]),_vm._v(" "),_c('ul',[_c('div',{staticClass:"row"},[(_vm.partial_payment_allowed)?_c('div',{staticClass:"col-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payment_type),expression:"payment_type"}],staticClass:"form-check-input",attrs:{"type":"radio","value":"Partial"},domProps:{"checked":_vm._q(_vm.payment_type,"Partial")},on:{"click":function($event){_vm.setPaymentModeAmount('partial')},"change":function($event){_vm.payment_type="Partial"}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label"},[_vm._v(" Partial ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payment_type),expression:"payment_type"}],staticClass:"form-check-input",attrs:{"type":"radio","value":"full"},domProps:{"checked":_vm._q(_vm.payment_type,"full")},on:{"click":function($event){_vm.setPaymentModeAmount('full')},"change":function($event){_vm.payment_type="full"}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label"},[_vm._v(" Full ")])])])]),_vm._v(" "),(_vm.part_payment)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payment_mode_amount),expression:"payment_mode_amount"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"amount"},domProps:{"value":(_vm.payment_mode_amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.payment_mode_amount=$event.target.value}}}):_vm._e(),_vm._v(" "),(!_vm.part_payment)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payment_mode_amount),expression:"payment_mode_amount"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"amount","readonly":""},domProps:{"value":(_vm.payment_mode_amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.payment_mode_amount=$event.target.value}}}):_vm._e(),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-end"},[(!_vm.processing &&
                          _vm.can_view_accounts &&
                          _vm.selected_account &&
                          _vm.payment_mode_amount &&
                          _vm.balance > 0
                          )?_c('a',{staticClass:"btn btn-sm btn-outline-primary",attrs:{"href":"#"},on:{"click":_vm.request_otp}},[_vm._v("Proceed")]):_vm._e()])]),_vm._v(" "),(_vm.show_otp_page)?_c('div',[_c('label',{attrs:{"for":"email"}},[_vm._v("Enter One Time Pin sent to your phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.one_time_pin_code),expression:"one_time_pin_code"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter Code Received","maxlength":"8"},domProps:{"value":(_vm.one_time_pin_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.one_time_pin_code=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-end"},[(!_vm.processing &&
                          _vm.can_view_accounts &&
                          _vm.selected_account &&
                          _vm.show_otp_page
                          )?_c('a',{staticClass:"btn btn-sm btn-outline-primary",attrs:{"href":"#"},on:{"click":_vm.authorize_payment}},[_vm._v("Confirm Payment")]):_vm._e()])]):_vm._e()]),_vm._v(" "),_vm._m(1)])])])])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header d-flex align-items-center"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{staticClass:"fe fe-x text-dark",attrs:{"aria-hidden":"true"}})])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer d-flex justify-content-end align-items-center"},[_c('a',{staticClass:"btn btn-link text-dark px-5",attrs:{"href":"#","data-dismiss":"modal"}},[_vm._v("Cancel")])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-10c51c28", __vue__options__)
  } else {
    hotAPI.reload("data-v-10c51c28", __vue__options__)
  }
})()}